(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('RcopiaPracticeInfo', RcopiaPracticeInfo);

    RcopiaPracticeInfo.$inject = ['$resource'];

    function RcopiaPracticeInfo ($resource) {
        var resourceUrl =  'api/rcopia-practice-infos/:id';

        return $resource(resourceUrl, {}, {
            'filter': { url: "api/rcopia-practice-infos/filter", method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
